import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SaveChangesButtons = ({ hasChanges, onSave, loading, disabled, onRevertChanges, defaultLabel, loadingLabel }) => {
  const { t } = useTranslation()

  if (!hasChanges) return null

  return (
    <Styles.ActionsContainer>
      <Button onClick={onRevertChanges} variant="outlined">
        {t('Cancelar')}
      </Button>
      <ButtonWithSpinner
        onClick={onSave}
        loading={loading}
        disabled={disabled}
        defaultLabel={defaultLabel || t('Guardar cambios')}
        loadingLabel={loadingLabel || t('Guardando cambios')}
        fullWidth
      />
    </Styles.ActionsContainer>
  )
}

export default SaveChangesButtons
